// extracted by mini-css-extract-plugin
module.exports = {"contentStyles":"styles_contentStyles__U2-lN"};